import React from "react"
import { TextLink } from "../../atoms/links/TextLink"
import styled from "styled-components"
import { colors, FlexContainer, Icon, Stack, Text } from "@carrotfertility/carotene"
import { SupportCenterLinks } from "../../../../utils/SupportCenterLinks"
import { ZendeskTextLink } from "../../atoms/links/ZendeskTextLink"

interface NavItemAndIconProps {
  onClick: () => void
  enabled?: boolean
  icon: string
  id: string
  link: string
  text: string
  leftPadding?: boolean
  exact?: boolean
  onClickOnly?: boolean
  showUnreadIndicator?: boolean
}

interface NavItemAndIconBodyProps {
  icon: string
  link: string
  text: string
  exact?: boolean
  showUnreadIndicator?: boolean
}

interface ZendeskNavItemAndIconProps {
  supportCenterLink?: SupportCenterLinks
  icon: string
  id: string
  link?: string
  text: string
  exact?: boolean
  showUnreadIndicator?: boolean
}

const StyledLinkContainer = styled.div`
  position: relative;
  transition: all 0.15s cubic-bezier(0.8, 0, 0.2, 1);
  cursor: pointer;
  &:hover {
    opacity: 0.5;
    transition: opacity 0.15s ease-in;
  }
`

const NavSideTick = styled.div<{ active: boolean }>`
  border-left-style: solid;
  border-width: 0.5rem;
  border-color: ${(props) => (props.active ? colors.base.carrotOrange : "transparent")};
  padding-left: 1rem;
`

function NavItemAndIcon({
  onClick,
  icon,
  id,
  link,
  text,
  exact,
  onClickOnly = false,
  showUnreadIndicator = false
}: NavItemAndIconProps): JSX.Element {
  // When it comes time to refactor, let's consider not using TextLink but rather a styled anchor tag
  return (
    <TextLink
      onClick={onClick}
      style={{ display: "block" }}
      underline={false}
      to={link}
      id={id}
      onClickOnly={onClickOnly}
    >
      <NavItemAndIconBody icon={icon} link={link} text={text} exact={exact} showUnreadIndicator={showUnreadIndicator} />
    </TextLink>
  )
}

function ZendeskNavItemAndIcon({
  supportCenterLink,
  icon,
  id,
  link,
  text,
  exact,
  showUnreadIndicator = false
}: ZendeskNavItemAndIconProps): JSX.Element {
  // When it comes time to refactor, let's consider not using TextLink but rather a styled anchor tag
  return (
    <ZendeskTextLink supportCenterLink={supportCenterLink} style={{ display: "block" }} underline={false} id={id}>
      <NavItemAndIconBody icon={icon} link={link} text={text} exact={exact} showUnreadIndicator={showUnreadIndicator} />
    </ZendeskTextLink>
  )
}

function NavItemAndIconBody({
  icon,
  link,
  text,
  exact,
  showUnreadIndicator = false
}: NavItemAndIconBodyProps): JSX.Element {
  const active =
    (exact && link === window.location.pathname) ||
    (!exact && window.location.pathname.startsWith(link)) ||
    (window.location.pathname.startsWith("/reimbursements/upload") && link === "/transactions")

  return (
    <StyledLinkContainer>
      <Text size="small" color="black80">
        <NavSideTick active={active}>
          <FlexContainer justifyContent="space-between" sx={{ paddingRight: "24px" }}>
            <Stack direction="row" spacing="tiny">
              <img
                style={{
                  fill: "currentColor",
                  color: "black",
                  stroke: "currentColor",
                  height: "22px",
                  width: "22px"
                }}
                className={"db"}
                src={`/images/${icon}.svg`}
                alt={icon}
              />
              <span style={{ top: 1.5, position: "absolute" }}>{text}</span>
            </Stack>
            {showUnreadIndicator ? (
              <FlexContainer width="9px" justifyContent="center" alignItems="center" sx={{ marginTop: "4px" }}>
                <Icon name="dot" color="carrotOrange" size="tiny" />
              </FlexContainer>
            ) : null}
          </FlexContainer>
        </NavSideTick>
      </Text>
    </StyledLinkContainer>
  )
}

export { NavItemAndIcon, ZendeskNavItemAndIcon }
